export default __webpack_public_path__ + "40cb004d3c641d0f7ea762b7b56d37e4.png";